/* RESPONSIBLE TEAM: team-standalone */

import Controller from '@ember/controller';

export default class AppStandaloneDeployFreshdeskTicketsIntegrateController extends Controller {
  // Using queryParams is the recommended usage for controllers in this codebase
  queryParams = [];
}
